import { Controller } from "@hotwired/stimulus"

// Handles admin decode interactions without touching the audit log.
export default class extends Controller {
  static targets = ["input", "result", "score", "scoreDigits", "alerts", "error"]

  maybeSubmit(event) {
    if (event.type === "keyup" && event.key !== "Enter") {
      return
    }

    this.submit(event)
  }

  async submit(event) {
    if (event) event.preventDefault()

    const token = this.inputTarget.value.trim()
    if (token.length === 0) {
      this.showError("Enter a synthetic SSN to decode.")
      return
    }

    try {
      const response = await fetch("/admin/test-data/credit-scores/decode", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({ ssn: token })
      })

      if (response.ok) {
        const data = await response.json()
        this.renderResult(data)
      } else {
        const errorPayload = await response.json().catch(() => ({}))
        const message =
          (errorPayload.error && errorPayload.error.message) ||
          errorPayload.error ||
          errorPayload.message ||
          "Unable to decode token."
        this.showError(message)
      }
    } catch (error) {
      this.showError("Unexpected error decoding token. Retry in a moment.")
    }
  }

  renderResult(data) {
    this.errorTarget.hidden = true
    this.errorTarget.textContent = ""

    this.scoreTarget.textContent = data.score
    this.scoreDigitsTarget.textContent = data.score_digits

    this.alertsTarget.innerHTML = ""
    if (data.alerts && data.alerts.length > 0) {
      data.alerts.forEach((alert) => {
        const item = document.createElement("li")
        item.className = "rounded border border-amber-200 bg-amber-50 px-3 py-2"
        item.innerHTML = `<span class="font-semibold">${alert.code}</span> — ${alert.description}`
        this.alertsTarget.appendChild(item)
      })
    } else {
      const emptyState = document.createElement("li")
      emptyState.className = "text-slate-500"
      emptyState.textContent = "No alerts"
      this.alertsTarget.appendChild(emptyState)
    }

    this.resultTarget.hidden = false
  }

  showError(message) {
    this.resultTarget.hidden = true
    this.alertsTarget.innerHTML = ""
    this.errorTarget.hidden = false
    this.errorTarget.textContent = message
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.getAttribute("content")
  }
}
